import { BasePresenter } from "core/presenter";

class CompanyIntegrationsNappPresenter extends BasePresenter {
  initialState() {
    return {
      loading: false,
      company: {}
    };
  }

  onEnabledChange(checked) {
    const { napp } = this.viewModel.company.integrations;
    napp.enabled = checked;
  }
}

export default CompanyIntegrationsNappPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/napp/presenter.js